module.exports = __webpack_public_path__ + "img/web-mail.c0771115.png";